<template>
    <div class="card h100">
        <div class="searchBBox h100">
            <!-- <div class="topBox">
                <el-input placeholder="请输入内容" v-model="searchBVal">
                    <template slot="append">
                        <el-button type="primary" icon="el-icon-search" @click="searchBFun()">搜索</el-button>
                    </template>
</el-input>
</div> -->
            <div class="bottomBox" @scroll="scrollBEnd" ref="scrollBContainer">
                <el-collapse v-model="activeNames" @change="clickExpand" accordion>
                    <el-collapse-item :name="i" v-for="(v, i) in bDataList" :key="i">
                        <template slot="title">
                            <div class="liTitle">
                                <div class="imgBox">
                                    <img class="w-40 h-40"
                                        :src="v.personalAvatar_xl ? v.personalAvatar_xl : require('@/assets/profile.png')"
                                        alt="" srcset="">
                                    <!-- <div class="isLine" :style="v.online == 1 ? 'background:#0CD85D;' : ''"></div> -->
                                    <div class="isLine" style="background:#0CD85D;"></div>
                                </div>
                                <div class="nameBox">{{ v.name }}
                                </div>
                                <div class="scBox">
                                    <template v-if="actNum == 1">
                                        <i class="el-icon-star-on"
                                            style="font-size: 20px;margin-right: 5px;color: red;"></i>
                                    </template>
                                    <template v-else>
                                        <i class="el-icon-star-off" style="font-size: 20px;margin-right: 5px;"></i>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <div class="tabBox">
                            <div class="tabBBox">
                                <div v-for="item in bTypeConfig" :key="item.type" class="tabBItem pointer"
                                    @click="checkBType(item.type)">
                                    <i :class="item.iconClass"
                                        :style="bType == item.type ? 'color:#2929c7; font-size: 20px;' : 'color:#999999; font-size: 20px;'"></i>
                                    <div :class="'nowrap ' + (bType == item.type ? 'active-color' : '')"
                                        :style="bType == item.type ? '' : 'color:#999999'">
                                        {{ item.label }}
                                    </div>
                                </div>
                                <!-- 在线筛选开关 -->
                                <div class="online-filter-container">
                                    <div class="online-filter-item" v-if="bType == 1">
                                        <el-switch v-model="filterOnlineUsers" @change="handleOnlineFilterChange"
                                            active-color="#2929c7" inactive-color="#dcdfe6" active-text="在线"
                                            inactive-text="" style="margin-right: 10px;">
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <!-- 黑名单不显示二级标签页 -->
                            <div class="tabMScroll" v-if="bType != 6">
                                <div v-for="tab in currentMTabs" :key="tab.type" class="tabMItem"
                                    @click="checkMType(tab.type)">
                                    <div class="tabContent color-gray" :class="mType == tab.type ? 'active-color' : ''">
                                        <img v-if="tab.icon" :src="tab.icon" alt="" class="tabIcon">
                                        <span>{{ tab.label }}</span>
                                    </div>
                                    <div class="line" :class="mType == tab.type ? '' : 'opacityCss'"></div>
                                </div>
                            </div>
                            <div style="margin-bottom: 10px;"
                                v-if="!(mType == 6 || bType == 3 || bType == 4 || bType == 6)">
                                <el-input placeholder="请输入id" v-model="searchMBVal">
                                    <template slot="append">
                                        <el-button type="primary" icon="el-icon-search"
                                            @click="searchMFun">搜索</el-button>
                                    </template>
                                </el-input>
                            </div>
                        </div>
                        <div class="mBox" @scroll="scrollEnd" ref="scrollContainer" v-if="bType == 1">
                            <div class="userBox pd-x-10" v-for="(d, t) in sonDataList" :key="t" @click="dyfFun(d)"
                                v-if="sonDataList.length > 0" :class="{ 'pinned': d.isPinned }">
                                <div class="topUserBox">
                                    <div class="leftUser">
                                        <div class="imgBox">
                                            <!-- 黑名单用户使用 avatar 字段，其他用户使用 userDetail.avatar_small -->
                                            <img :src="d.avatar || d.userDetail?.avatar_small || require('@/assets/profile.png')"
                                                class="w-40 h-40 round" alt="" srcset="">
                                            <div class="status"
                                                :class="d.userDetail && d.userDetail.is_online ? 'checkStatus' : ''">
                                            </div>
                                        </div>
                                        <div class="xxBox">
                                            <div class="nameBox flex row middle mb-4">
                                                <!-- 黑名单用户使用 name 字段，其他用户使用 userDetail.name -->
                                                {{ d.name || d.userDetail?.name }}
                                                <img class="w-16 h-16 ml-4" v-if="d.userDetail?.isVip == 1"
                                                    src="@/assets/icon/vip.png" alt="">
                                            </div>
                                            <div class="nameBox">{{ d.lastMessage ? messageFormat(d) : '已拉黑' }}</div>
                                        </div>
                                    </div>
                                    <div class="sccBox flex row middle">
                                        <img v-if="d.isBookmarked == 1" class="w-20 h-20" src="@/assets/bookmark.png"
                                            alt="">
                                        <!-- 移出黑名单按钮 -->
                                        <el-button v-if="mType == 6" type="primary" size="mini"
                                            @click.stop="removeFromBlacklist(d)" class="unblock-button"
                                            style="margin-left: 10px;">
                                            移出黑名单
                                        </el-button>
                                        <img v-if="d.isPinned" class="pinned_icon" src="@/assets/svg/pinned.svg">
                                    </div>
                                </div>
                                <div class="bottomUserBox">
                                    <!-- 黑名单用户显示拉黑时间，其他用户显示最后访问时间 -->
                                    <span v-if="d.dateBlocked">拉黑时间: {{ formatTime(d.dateBlocked) }}</span>
                                    <span v-else>{{ formatTime(d.dateUpdated) }}</span>
                                </div>
                            </div>
                            <img v-if="loadingImgShow" ref="loadingImg" class="loadingImg rotate360"
                                src="@/assets/loading.png" alt="">
                            <template v-else>
                                <div v-if="sonDataList.length == 0">
                                    <div class="text-center color-gray fs-14 mt-20">
                                        暂无数据
                                    </div>
                                </div>
                                <div v-if="sonDataList.length > 0 && !isSonMore">
                                    <div class="text-center color-gray fs-14 mt-20">
                                        没有更多了
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="mBox" @scroll="scrollEnd" ref="scrollContainer" v-if="bType == 2">
                            <div class="userBox pd-x-10" v-for="(d, t) in sonDataList" :key="t" @click="dyfFun(d)"
                                v-if="sonDataList.length > 0">
                                <div class="topUserBox">
                                    <div class="leftUser">
                                        <div class="imgBox">
                                            <img :src="d.userDetail?.avatar_small ? d.userDetail?.avatar_small : require('@/assets/profile.png')"
                                                class="w-40 h-40 round" alt="" srcset="">
                                            <div class="status"
                                                :class="d.userDetail && d.userDetail.is_online ? 'checkStatus' : ''">
                                            </div>
                                        </div>
                                        <div class="xxBox">
                                            <div class="nameBox flex row middle mb-4">
                                                {{ d.userDetail?.name }}
                                                <img class="w-16 h-16 ml-4" v-if="d.userDetail?.isVip == 1"
                                                    src="@/assets/icon/vip.png" alt="">
                                            </div>
                                            <div class="nameBox">{{ d.correspondence?.last?.title }}</div>
                                        </div>
                                    </div>
                                    <div class="sccBox flex row middle">
                                        <img v-if="d.isBookmarked == 1" class="w-20 h-20" src="@/assets/bookmark.png"
                                            alt="">
                                    </div>
                                </div>
                                <div class="bottomUserBox">
                                    {{ formatTime(d.dateUpdated) }}
                                </div>
                            </div>
                            <img v-if="loadingImgShow" ref="loadingImg" class="loadingImg rotate360"
                                src="@/assets/loading.png" alt="">
                            <template v-else>
                                <div v-if="sonDataList.length == 0">
                                    <div class="text-center color-gray fs-14 mt-20">
                                        暂无数据
                                    </div>
                                </div>
                                <div v-if="sonDataList.length > 0 && !isSonMore">
                                    <div class="text-center color-gray fs-14 mt-20">
                                        没有更多了
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- 黑名单显示区域 -->
                        <div class="mBox" @scroll="scrollEnd" ref="scrollContainer" v-if="bType == 6">
                            <div class="userBox pd-x-10" v-for="(d, t) in sonDataList" :key="t" @click="dyfFun(d)"
                                v-if="sonDataList.length > 0">
                                <div class="topUserBox">
                                    <div class="leftUser">
                                        <div class="imgBox">
                                            <!-- 黑名单用户使用 avatar 字段，其他用户使用 userDetail.avatar_small -->
                                            <img :src="d.avatar || d.userDetail?.avatar_small || require('@/assets/profile.png')"
                                                class="w-40 h-40 round" alt="" srcset="">
                                            <div class="status"
                                                :class="d.userDetail && d.userDetail.is_online ? 'checkStatus' : ''">
                                            </div>
                                        </div>
                                        <div class="xxBox">
                                            <div class="nameBox flex row middle mb-4">
                                                <!-- 黑名单用户使用 name 字段，其他用户使用 userDetail.name -->
                                                {{ d.name || d.userDetail?.name }}
                                                <img class="w-16 h-16 ml-4" v-if="d.userDetail?.isVip == 1"
                                                    src="@/assets/icon/vip.png" alt="">
                                            </div>
                                            <div class="nameBox">{{ d.lastMessage ? messageFormat(d) : '已拉黑' }}</div>
                                        </div>
                                    </div>
                                    <div class="sccBox flex row middle">
                                        <img v-if="d.isBookmarked == 1" class="w-20 h-20" src="@/assets/bookmark.png"
                                            alt="">
                                        <!-- 移出黑名单按钮 -->
                                        <el-button type="primary" size="mini" @click.stop="removeFromBlacklist(d)"
                                            class="unblock-button" style="margin-left: 10px;">
                                            移出黑名单
                                        </el-button>
                                    </div>
                                </div>
                                <div class="bottomUserBox">
                                    <!-- 黑名单用户显示拉黑时间，其他用户显示最后访问时间 -->
                                    <span v-if="d.dateBlocked">拉黑时间: {{ formatTime(d.dateBlocked) }}</span>
                                    <span v-else>{{ formatTime(d.dateUpdated) }}</span>
                                </div>
                            </div>
                            <img v-if="loadingImgShow" ref="loadingImg" class="loadingImg rotate360"
                                src="@/assets/loading.png" alt="">
                            <template v-else>
                                <div v-if="sonDataList.length == 0">
                                    <div class="text-center color-gray fs-14 mt-20">
                                        暂无数据
                                    </div>
                                </div>
                                <div v-if="sonDataList.length > 0 && !isSonMore">
                                    <div class="text-center color-gray fs-14 mt-20">
                                        没有更多了
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!-- 隐藏的礼物&心愿单功能，保留代码以备后用 -->
                        <!-- <div class="mBox" @scroll="onScroll" ref="giftScrollContainer" v-if="bType == 3">
                            <template v-if="mType == 1">
                                <div v-if="wishList.length > 0">
                                    <div class="userBox pd-x-10 pb-10" v-for="(item, index) in wishList"
                                        :key="item.idPresent">
                                        <div class="topUserBox">
                                            <div class="leftUser">
                                                <div class="imgBox">
                                                    <img :src="item.imageUrl" :alt="item.name" class="w-40 h-40 round">
                                                </div>
                                                <div class="xxBox">
                                                    <div class="nameBox">{{ item.name }}</div>
                                                </div>
                                            </div>
                                            <div class="sccBox flex row middle">
                                                <el-button type="danger" size="mini"
                                                    @click.stop="removeFromWishlist(item, index)"
                                                    class="remove-wishlist-button">
                                                    移出心愿单
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center color-gray fs-14 mt-20">
                                    暂无心愿单数据
                                </div>
                            </template>
                            <template v-if="mType == 2">
                                <div v-if="presentList.length > 0">
                                    <div class="category-nav-fixed">
                                        <div class="category-nav-items">
                                            <div v-for="category in categoryList" :key="category.id"
                                                :class="['category-nav-item', { 'active': activeCategoryId === category.id }]"
                                                :data-category-id="category.id" @click="scrollToCategory(category.id)">
                                                <img :src="category.imageUrl" :alt="category.name"
                                                    class="category-nav-icon">
                                                <span>{{ category.name }}</span>
                                                <div v-if="getWishlistCountByCategory(category.id) > 0"
                                                    class="wishlist-badge-count">
                                                    {{ getWishlistCountByCategory(category.id) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="category-section" v-for="category in categoryList" :key="category.id">
                                        <div class="category-header" :id="'category-' + category.id">
                                            <div class="category-info">
                                                <img :src="category.imageUrl" :alt="category.name"
                                                    class="category-icon">
                                                <span class="category-name">{{ category.name }}</span>
                                            </div>
                                        </div>
                                        <div class="gift-list">
                                            <div class="userBox pd-x-10 pb-10"
                                                v-for="(item, index) in getGiftsByCategory(category.id)" :key="item.id">
                                                <div class="topUserBox">
                                                    <div class="leftUser">
                                                        <div class="imgBox">
                                                            <img :src="item.imageUrl" :alt="item.name"
                                                                class="w-40 h-40 round">
                                                            <div v-if="isInWishlist(item.id)" class="wishlist-badge">
                                                                <img src="@/assets/svg/heart.svg" alt=""
                                                                    class="w-16 h-16">
                                                            </div>
                                                        </div>
                                                        <div class="xxBox">
                                                            <div class="nameBox">{{ item.name }}</div>
                                                            <div v-if="isInWishlist(item.id)" class="wishlist-status">
                                                                已在心愿单
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="sccBox flex row middle">
                                                        <el-button v-if="!isInWishlist(item.id)" type="primary"
                                                            size="mini" @click.stop="addToWishlist(item)"
                                                            class="add-wishlist-button">
                                                            加入心愿单
                                                        </el-button>
                                                        <el-button v-else type="danger" size="mini"
                                                            @click.stop="removeFromWishlistById(item.id)"
                                                            class="remove-wishlist-button">
                                                            移出心愿单
                                                        </el-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center color-gray fs-14 mt-20">
                                    暂无礼物数据
                                </div>
                            </template>
                        </div> -->
                        <!-- 隐藏的礼物记录功能，保留代码以备后用 -->
                        <!-- <div class="mBox" @scroll="onScroll" ref="giftScrollContainer" v-if="bType == 4">
                            <template v-if="mType == 1">
                                <img v-if="loadingImgShow" ref="loadingImg" class="loadingImg rotate360"
                                    src="@/assets/loading.png" alt="">
                                <template v-else>
                                    <div v-if="giftRecordList.length > 0">
                                        <div class="userBox pd-x-10" v-for="(item, index) in giftRecordList"
                                            :key="index">
                                            <div class="topUserBox">
                                                <div class="leftUser">
                                                    <div class="imgBox">
                                                        <img :src="item.userDetail?.avatar_small || require('@/assets/profile.png')"
                                                            class="w-40 h-40 round" alt="" srcset="">
                                                        <div class="status"
                                                            :class="item.userDetail && item.userDetail.is_online ? 'checkStatus' : ''">
                                                        </div>
                                                    </div>
                                                    <div class="xxBox">
                                                        <div class="nameBox flex row middle">
                                                            {{ item.userDetail?.name }}
                                                            <img class="w-16 h-16 ml-4" v-if="item.userDetail?.isVip == 1"
                                                                src="@/assets/icon/vip.png" alt="">
                                                        </div>
                                                        <div class="nameBox"
                                                            style="white-space: wrap;text-overflow: initial;line-height: 16px;">
                                                            {{ item.message || '向你发送一个礼物' }}</div>
                                                    </div>
                                                </div>
                                                <div class="sccBox flex row middle">
                                                    <div class="gift-info">
                                                        <img :src="item.gift?.imageSrc" :alt="item.gift?.name"
                                                            class="w-50 h-50 round gift-image">
                                                    </div>
                                                    <div class="action-icons">
                                                        <img src="@/assets/svg/pd-email.svg"
                                                            class="w-20 h-20 action-icon"
                                                            @click.stop="toChat(item, 'email')" alt="发送邮件" title="发送邮件">
                                                        <img src="@/assets/svg/pd-msg.svg" class="w-20 h-20 action-icon"
                                                            @click.stop="toChat(item, 'chat')" alt="开始聊天" title="开始聊天">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="bottomUserBox">
                                                {{ formatTime(item.dateSent) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="text-center color-gray fs-14 mt-20">
                                        暂无礼物记录
                                    </div>
                                </template>
                            </template>
                            <template v-if="mType == 2">
                                <div class="gift-analysis-container">
                                    <div class="filter-section">
                                        <div class="date-filters">
                                            <div class="date-input">
                                                <el-date-picker v-model="giftAnalysis.dateRange" type="daterange"
                                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                    @change="onDateRangeChange" style="width: 100%;" clearable>
                                                </el-date-picker>
                                            </div>
                                            <el-button type="primary" @click="filterGiftData" class="filter-btn">
                                                筛选
                                            </el-button>
                                        </div>
                                    </div>
                                    <div class="stats-section">
                                        <div class="stat-card">
                                            <div class="stat-number">{{ giftAnalysis.totalGifts }}</div>
                                            <div class="stat-label">总礼物数量</div>
                                        </div>
                                        <div class="stat-card">
                                            <div class="stat-number">{{ giftAnalysis.totalCredits }} cr</div>
                                            <div class="stat-label">总积分</div>
                                        </div>
                                        <div class="stat-card">
                                            <div class="stat-number">{{ giftAnalysis.totalUsers }}</div>
                                            <div class="stat-label">送礼用户数</div>
                                        </div>
                                    </div>
                                    <div class="table-section">
                                        <el-table :data="giftAnalysis.filteredData" style="width: 100%"
                                            :header-cell-style="{ backgroundColor: '#f0f8ff', color: '#333' }"
                                            v-loading="giftAnalysis.loading">
                                            <el-table-column prop="gift.name" label="礼物名称" min-width="80" width="auto">
                                                <template slot-scope="scope">
                                                    <div class="gift-name-cell">
                                                        <span>{{ scope.row.gift.name }}</span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="dateSent" label="发送时间" min-width="80" width="auto"
                                                sortable>
                                                <template slot-scope="scope">
                                                    {{ formatGiftTime(scope.row.dateSent) }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="userDetail.name" label="发送者" min-width="60"
                                                width="auto">
                                                <template slot-scope="scope">
                                                    <div class="sender-cell">
                                                        <span>{{ scope.row.userDetail?.name || '未知用户' }}</span>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="gift.cost" label="积分" min-width="60" width="auto"
                                                sortable>
                                                <template slot-scope="scope">
                                                    <span class="credits-amount">{{ scope.row.gift.cost }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </template>
                        </div> -->
                    </el-collapse-item>
                </el-collapse>
                <img v-if="loadingBImgShow" ref="loadingImg" class="loadingImg rotate360" src="@/assets/loading.png"
                    alt="">
            </div>
        </div>
    </div>
</template>

<script>
import { getMyList } from '@/api/dialogue'
import { getChatDialogsByCriteria, getChatDialogsByPairs, getConnectionsMails } from '@/api/talkytimes/message'
import {
    getConnectionBlockList,
    removeConnectionBlock,
    getPresentList,
    getWishList,
    updateWishList,
    getReceivedList,
    getReceivedStatistics
} from '@/api/talkytimes/user'
import store from '@/store'
import { messageFormat, formatTime } from '@/utils/talkytimesFormat'
import Cookies from 'js-cookie'

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        searchKeyword: {
            type: String,
            default: ''
        }
    },
    components: {},
    data() {
        return {
            searchBVal: '', // 搜索自己用户
            searchMBVal: '', // 搜索用户下的好友
            activeNames: '0',
            bType: 1,
            mType: 1,
            actNum: false,
            bDataList: [],
            bTotal: 0,
            pageSize: 40,
            sonDataList: [],
            sonTotal: 0,
            currentCheckSon: '',
            isSonMore: false, //是否还有更多子元素
            pageBNumber: 1,
            isMore: false, //是否还有更多子元素
            loadingImgShow: false, // 是否显示加载图片
            loadingBImgShow: false, // 是否显示加载图片

            // 新增bType配置
            bTypeConfig: [{
                type: 1,
                label: '聊天',
                iconClass: 'el-icon-chat-dot-square'
            },
            // {
            //     type: 2,
            //     label: '邮件',
            //     iconClass: 'el-icon-message'
            // }
            {
                type: 6,
                label: '黑名单',
                iconClass: 'el-icon-user-solid'
            }
                // 隐藏的功能，保留代码以备后用
                // {
                //     type: 3,
                //     label: '礼物&心愿单',
                //     iconClass: 'el-icon-shopping-bag-1'
                // },
                // {
                //     type: 4,
                //     label: '礼物记录',
                //     iconClass: 'el-icon-sold-out'
                // }
            ],
            // tab配置数据
            mTabsConfig: {
                1: [ // bType == 1 (聊天)
                    { type: 1, label: '活跃', },
                    { type: 2, label: '收藏', },
                    { type: 3, label: '会员', icon: require('@/assets/icon/vip.png') },
                    // { type: 4, label: '待回复', },
                    { type: 5, label: '全部', },
                    // { type: 6, label: '黑名单', }
                ],
                2: [ // bType == 2 (邮件)
                    { type: 1, label: '收件箱', },
                    { type: 2, label: '受限的', },
                    { type: 3, label: '已收藏', },
                    { type: 4, label: 'VIP', icon: require('@/assets/icon/vip.png') },
                    { type: 5, label: '发件箱', },
                    { type: 6, label: '垃圾箱', }
                ],
                3: [ // bType == 3 (礼物&心愿单)
                    { type: 1, label: '心愿单', },
                    { type: 2, label: '全部礼物', },
                ],
                4: [ // bType == 4 (收礼记录)
                    { type: 1, label: '所有记录', },
                    { type: 2, label: '分析', },
                ]
            },
            mTypeObj1: {
                1: 'active',
                2: 'bookmarked',
                3: 'vip',
                4: 'unanswered',
                5: ''
            },
            mTypeObj2: {
                1: 'inbox/all',
                2: 'has_limits',
                3: 'starred',
                4: 'vip',
                5: 'outbox',
                6: 'trash'
            },
            chatPageParams: {
                criteria: [], // active：活跃会话，bookmarked：收藏会话，vip：会员会话，unanswered：待回复，''：全部会话
                cursor: '', // 将上次请求的cursor传入下次请求以作为分页依据
                limit: 15
            },
            emailPageParams: {
                type: 'inbox/all', // 1、inbox/all（对应Inbox）,2、has_limits（对应Active limits），3、starred(对应Starred)，4、vip(对应VIP)，5、outbox(对应Outbox)，6、trash(对应Trash)
                offset: 0,
                limit: 15,
                femaleIds: [],
                idRegularUser: ''
            },
            blockListParams: {
                idLast: 0,
                limit: 15
            },
            wishList: [],
            presentList: [],
            categoryList: [],
            activeCategoryId: null, // 当前激活的分类ID
            giftRecordList: [], // 新增：礼物记录列表
            giftAnalysis: {
                dateRange: null,
                totalGifts: 0,
                totalCredits: 0,
                totalUsers: 0,
                filteredData: [],
                loading: false
            },
            filterOnlineUsers: true, // 是否筛选在线用户，默认为true
            originalBDataList: [], // 原始用户列表数据
            filteredBDataList: [] // 过滤后的用户列表数据
        };
    },
    computed: {
        currentMTabs() {
            return this.mTabsConfig[this.bType] || [];
        }
    },
    watch: {
        activeCategoryId: {
            handler(newVal) {
                if (newVal && this.mType === 2) {
                    this.$nextTick(() => {
                        this.scrollCategoryNavToView(newVal);
                    });
                }
            },
            immediate: false
        },
        searchKeyword: {
            handler(newVal) {
                this.applySearchFilter()
            },
            immediate: false
        }
    },
    methods: {
        messageFormat,
        formatTime,
        dyfFun(v) {
            console.log(v)
            this.$emit('clickHistory', v)
        },
        searchBFun() {
            this.getuserlist('new')
        },
        searchMFun() {
            this.filterOnlineUsers = true;
            this.expandList('new')
        },
        // 是否滚动到当前元素底部
        scrollBEnd() {
            this.$nextTick(() => {
                // 防抖处理
                if (this.scrollDebounce) {
                    clearTimeout(this.scrollDebounce);
                }
                this.scrollDebounce = setTimeout(() => {
                    const containerB = this.$refs.scrollBContainer;
                    console.log(this.$refs)
                    console.log(containerB, 'containerB')
                    // 添加50px的缓冲区域
                    const threshold = 50;
                    const isBottom = containerB.scrollHeight - containerB.scrollTop <= containerB.clientHeight + threshold;
                    console.log(containerB.scrollHeight, containerB.scrollTop, containerB.clientHeight)
                    console.log("isBottom:::" + isBottom)
                    if (isBottom && this.isMore) {
                        console.log("aaa1223123")
                        this.pageBNumber++
                        this.getuserlist()
                    }
                }, 100);
            })
        },
        // 获取用户列表
        getuserlist(t) {
            if (t == 'new') {
                this.pageBNumber == 1
                this.bDataList = []
            }
            this.loadingBImgShow = true; // 显示加载图片
            getMyList().then(res => {
                // 保存原始数据
                this.originalBDataList = res.data || []
                // 应用搜索过滤
                this.applySearchFilter()
            }).finally(() => {
                this.isMore = false; // 默认不分页
                this.loadingBImgShow = false; // 隐藏加载图片
            });
        },
        checkBType(t) {
            switch (t) {
                case 1:
                    this.bType = 1;
                    this.mType = 1;
                    this.giftRecordList = []; // 重置礼物记录列表
                    this.expandList('reset');
                    break;
                case 2:
                    this.bType = 2;
                    this.mType = 1;
                    this.giftRecordList = []; // 重置礼物记录列表
                    this.expandList('reset');
                    break;
                case 6:
                    // 黑名单功能
                    this.bType = 6;
                    this.mType = 6; // 直接设置为黑名单类型
                    this.sonDataList = [];
                    this.blockListParams.idLast = 0;
                    this.giftRecordList = []; // 重置礼物记录列表
                    this.getBlackList();
                    break;
                // 隐藏的功能，保留代码以备后用
                // case 3:
                //     this.bType = 3;
                //     this.mType = 1;
                //     this.giftRecordList = []; // 重置礼物记录列表
                //     this.getPresentOrWish();
                //     break;
                // case 4:
                //     this.bType = 4;
                //     this.mType = 1;
                //     this.giftRecordList = []; // 重置礼物记录列表
                //     this.getGiftRecordList();
                //     break;
                default:
                    console.warn('未知的 bType:', t);
                    break;
            }
        },
        checkMType(t) {
            switch (t) {
                case 1:
                    this.mType = 1;
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                        this.getGiftRecordList();
                    } else {
                        this.expandList('reset');
                    }
                    break;
                case 2:
                    this.mType = 2;
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                        // 初始化礼物数据分析
                        this.initGiftAnalysis();
                    }
                    this.expandList('reset');
                    break;
                case 3:
                    this.mType = 3;
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                    }
                    this.expandList('reset');
                    break;
                case 4:
                    this.mType = 4;
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                    }
                    this.expandList('reset');
                    break;
                case 5:
                    this.mType = 5;
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                    }
                    this.expandList('reset');
                    break;
                case 6:
                    this.mType = 6;
                    this.sonDataList = [];
                    this.blockListParams.idLast = 0;
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                    }
                    this.getBlackList();
                    break;
                default:
                    console.warn('未知的 mType:', t);
                    break;
            }
        },
        // 是否滚动到当前元素底部
        scrollEnd() {
            console.log('scrollEnd')
            // 防抖处理
            if (this.scrollDebounce) {
                clearTimeout(this.scrollDebounce);
            }
            this.scrollDebounce = setTimeout(() => {
                const container = this.$refs.scrollContainer[0];
                // 添加50px的缓冲区域
                const threshold = 50;
                const isBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + threshold;
                console.log(container.scrollHeight, container.scrollTop, container.clientHeight)
                if (isBottom && this.isSonMore && !this.loadingImgShow) {
                    // 加载黑名单
                    if (this.mType == 6) {
                        this.getBlackList()
                    } else {
                        this.expandList('more')
                    }
                }
            }, 100);
        },
        clickExpand(val) {
            if (val !== '') {
                this.expandList(val)
            }
        },
        expandList(val) {
            console.log('expandList:::::', val, this.bDataList)
            if (this.bDataList[val]) {
                localStorage.setItem('activeUser', JSON.stringify(this.bDataList[val]))
            }

            this.loadingImgShow = true; // 显示加载图片
            switch (val) {
                case 'more':
                    // 滚动加载
                    break;
                case 'new':
                    // 搜索用户时默认筛选在线
                    this.filterOnlineUsers = true;
                    this.resetChatPageParams()
                    this.sonDataList = []
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                    }
                    break;
                case 'reset':
                    // 首次/重置查询
                    this.resetChatPageParams()
                    this.sonDataList = []
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                    }
                    break;
                default:
                    // 点击某个用户查询，默认筛选在线
                    this.filterOnlineUsers = true;
                    this.resetChatPageParams()
                    this.currentCheckSon = this.bDataList[val];
                    this.sonDataList = [];
                    if (this.bType == 4) {
                        this.giftRecordList = []; // 重置礼物记录列表
                    }
                    break;
            }
            if (this.bType == 1) { // 聊天
                this.chatPageParams.criteria = [this.mTypeObj1[this.mType]];
                // 如果启用了在线筛选，添加 online 条件
                if (this.filterOnlineUsers) {
                    this.chatPageParams.criteria.push('online');
                }
                this.getTalkytimesUserList()
            } else if (this.bType == 2) { // 邮件
                let params = {
                    type: this.mTypeObj2[this.mType],
                    idRegularUser: this.searchMBVal,
                    femaleIds: [69593048]
                }
                this.emailPageParams = {
                    ...this.emailPageParams,
                    ...params
                }
                getConnectionsMails(this.emailPageParams).then(async res => {
                    if (res.data.mails.length > 0) {
                        // 使用 store 匹配用户信息
                        const dialogsWithUserInfo = await store.dispatch('userInfo/matchChatListUserInfo', { chatList: res.data.mails, userIdField: 'idRegularUser' });
                        this.sonDataList = [...this.sonDataList, ...dialogsWithUserInfo];
                    }
                    this.emailPageParams.offset += res.data.mails.length;
                    this.isSonMore = res.data.mails.length >= this.emailPageParams.limit;
                }).finally(() => {
                    this.loadingImgShow = false; // 隐藏加载图片
                });
            } else if (this.bType == 6) { // 黑名单
                // 黑名单功能已在 checkBType 中处理
                this.loadingImgShow = false; // 隐藏加载图片
            }
            // 隐藏的功能，保留代码以备后用
            // else if (this.bType == 3) { // 礼物&心愿单
            //     this.getPresentOrWish()
            // } else if (this.bType == 4) { // 收礼记录
            //     this.getGiftRecordList()
            // }
        },
        getPresentOrWish() {
            if (this.mType == 1) {
                getWishList().then(res => {
                    console.log('心愿单', res)
                    this.wishList = res || [];
                })
            } else if (this.mType == 2) {
                getPresentList({
                    cursor: "",
                    idRegularUser: 69593048,
                    limit: 30
                }).then(res => {
                    console.log('礼物', res.items)
                    this.presentList = res.items || [];
                    // 获取礼物列表后，处理分类
                    this.getCategoryList();
                    // 设置第一个分类为激活状态
                    if (this.categoryList.length > 0) {
                        this.activeCategoryId = this.categoryList[0].id;
                    }
                })
            }
        },
        // 获取黑名单
        getBlackList() {
            this.loadingImgShow = true; // 显示加载图片
            getConnectionBlockList({
                ...this.blockListParams
            }).then(async res => {
                console.log('黑名单列表：', res)
                if (res && res.connections && res.connections.length > 0) {
                    // 直接使用 connections 数组，因为黑名单数据已经包含了用户信息
                    this.sonDataList = [...this.sonDataList, ...res.connections];
                }
                // 确保有数据后再更新分页参数
                if (res.connections && res.connections.length > 0) {
                    this.blockListParams.idLast = res.connections[res.connections.length - 1].id;
                    this.isSonMore = res.connections.length >= this.blockListParams.limit;
                } else {
                    this.isSonMore = false;
                }
            }).catch(error => {
                console.error('获取黑名单列表失败:', error);
                this.isSonMore = false;
            }).finally(() => {
                this.loadingImgShow = false; // 隐藏加载图片
            })
        },
        getTalkytimesUserList() {
            return new Promise((resolve, reject) => {
                if (this.searchMBVal) {
                    // 搜索好友
                    getChatDialogsByPairs({
                        idsRegularUser: [parseInt(this.searchMBVal)]
                    }).then(async res => {
                        if (res.length > 0) {
                            // 首先过滤掉 isBlocked 为 true 的数据
                            const filteredDialogs = res.filter(dialog => !dialog.isBlocked);

                            // 使用 store 匹配用户信息
                            const dialogsWithUserInfo = await store.dispatch('userInfo/matchChatListUserInfo', { chatList: filteredDialogs });
                            this.sonDataList = [...this.sonDataList, ...dialogsWithUserInfo];
                        }
                        this.isSonMore = false
                    }).finally(() => {
                        this.loadingImgShow = false; // 隐藏加载图片
                        console.log('加载中', this.loadingImgShow)
                    });
                } else {
                    // 查看所有好友
                    getChatDialogsByCriteria(this.chatPageParams).then(async res => {
                        if (res.dialogs.length > 0) {
                            // 首先过滤掉 isBlocked 为 true 的数据
                            const filteredDialogs = res.dialogs.filter(dialog => !dialog.isBlocked);

                            // 使用 store 匹配用户信息
                            const dialogsWithUserInfo = await store.dispatch('userInfo/matchChatListUserInfo', { chatList: filteredDialogs });
                            this.sonDataList = [...this.sonDataList, ...dialogsWithUserInfo];
                            this.chatPageParams.cursor = res.cursor;
                        }
                        this.isSonMore = res.dialogs.length >= this.chatPageParams.limit;
                    }).finally(() => {
                        this.loadingImgShow = false; // 隐藏加载图片
                        console.log('加载中', this.loadingImgShow)
                    });
                }
            })
        },
        resetChatPageParams() {
            this.isSonMore = false;
            this.chatPageParams = {
                criteria: [],
                cursor: '',
                limit: 15
            }
        },
        // 移出黑名单
        removeFromBlacklist(user) {
            this.$confirm(`确定要将用户 "${user.name}" 移出黑名单吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 使用 idUser 字段，这是黑名单数据中的用户ID字段
                const userId = user.idUser;

                removeConnectionBlock({ idInterlocutor: userId }).then(res => {
                    this.$message.success('移出黑名单成功！');
                    // 从当前列表中移除该用户
                    const index = this.sonDataList.findIndex(item => (item.idUser) === userId);
                    if (index > -1) {
                        this.sonDataList.splice(index, 1);
                    }
                }).catch(error => {
                    console.error('移出黑名单失败:', error);
                    this.$message.error('移出黑名单失败！');
                });
            })
        },
        // 获取分类列表
        getCategoryList() {
            const categories = new Map();
            this.presentList.forEach(item => {
                if (item.category && !categories.has(item.category.id)) {
                    categories.set(item.category.id, {
                        ...item.category,
                        gifts: []
                    });
                }
            });

            // 转换为数组并按优先级排序
            this.categoryList = Array.from(categories.values())
                .sort((a, b) => a.priority - b.priority);
        },
        // 根据分类ID获取礼物列表
        getGiftsByCategory(categoryId) {
            return this.presentList
                .filter(item => item.category && item.category.id === categoryId)
                .sort((a, b) => a.priority - b.priority);
        },
        // 滚动到指定分类
        scrollToCategory(categoryId) {
            const element = document.getElementById(`category-${categoryId}`);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },
        // 监听滚动，更新激活的分类
        onScroll() {
            if (this.mType !== 2 || !this.categoryList.length) {
                return;
            }

            const container = this.$refs.giftScrollContainer[0];
            if (!container) {
                return;
            }

            const scrollTop = container.scrollTop;
            const containerHeight = container.clientHeight;

            // 遍历所有分类，找到当前可见的分类
            for (let i = this.categoryList.length - 1; i >= 0; i--) {
                const category = this.categoryList[i];
                const element = document.getElementById(`category-${category.id}`);
                if (element) {
                    const elementTop = element.offsetTop;
                    const elementHeight = element.offsetHeight;

                    // 如果分类标题在可视区域内，则激活该分类
                    if (scrollTop + 100 <= elementTop && scrollTop + containerHeight >= elementTop) {
                        if (this.activeCategoryId !== category.id) {
                            this.activeCategoryId = category.id;
                        }
                        break;
                    }
                }
            }
        },
        // 移出心愿单
        removeFromWishlist(item, index) {
            this.$confirm(`确定要将 "${item.name}" 移出心愿单吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 构建新的心愿单ID数组（移除指定礼物）
                const newWishListIds = this.wishList
                    .filter((wishItem, i) => i !== index) // 排除要移除的礼物
                    .map(wishItem => wishItem.idPresent); // 提取ID

                // 调用API更新心愿单
                updateWishList({
                    idsPresents: newWishListIds
                }).then(res => {
                    this.$message.success('移出心愿单成功！');
                    // 从当前列表中移除该项目
                    this.updateWishList();
                }).catch(error => {
                    console.error('移出心愿单失败:', error);
                    this.$message.error('移出心愿单失败！');
                });
            })
        },
        // 加入心愿单
        addToWishlist(item) {
            this.$confirm(`确定要将 "${item.name}" 加入心愿单吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 构建新的心愿单ID数组（添加新礼物）
                const currentWishListIds = this.wishList.map(wishItem => wishItem.idPresent);
                const newWishListIds = [...currentWishListIds, item.id];

                // 调用API更新心愿单
                updateWishList({
                    idsPresents: newWishListIds
                }).then(res => {
                    this.$message.success('加入心愿单成功！');
                    // 重新调用心愿单接口，保证顺序
                    this.updateWishList();
                }).catch(error => {
                    console.error('加入心愿单失败:', error);
                    this.$message.error('加入心愿单失败！');
                });
            })
        },
        // 更新心愿单列表
        updateWishList() {
            getWishList().then(res => {
                this.wishList = res;
            })
        },
        // 检查礼物是否已在心愿单中
        isInWishlist(giftId) {
            return this.wishList.some(wishItem => wishItem.idPresent === giftId);
        },
        // 通过礼物ID移出心愿单
        removeFromWishlistById(giftId) {
            const wishItem = this.wishList.find(item => item.idPresent === giftId);
            if (wishItem) {
                this.removeFromWishlist(wishItem, this.wishList.findIndex(item => item.idPresent === giftId));
            }
        },
        // 滚动分类导航到可视区域
        scrollCategoryNavToView(categoryId) {
            const categoryNavContainer = document.querySelector('.category-nav-items');
            if (!categoryNavContainer) return;

            const targetItem = categoryNavContainer.querySelector(`[data-category-id="${categoryId}"]`);
            if (!targetItem) return;

            // 计算目标元素相对于容器的位置
            const containerRect = categoryNavContainer.getBoundingClientRect();
            const targetRect = targetItem.getBoundingClientRect();

            // 计算需要滚动的距离
            const scrollLeft = targetItem.offsetLeft - (containerRect.width / 2) + (targetItem.offsetWidth / 2);

            // 平滑滚动到目标位置
            categoryNavContainer.scrollTo({
                left: Math.max(0, scrollLeft),
                behavior: 'smooth'
            });
        },
        // 获取指定分类下在心愿单中的礼物数量
        getWishlistCountByCategory(categoryId) {
            if (!this.wishList || !this.presentList) return 0;

            // 获取该分类下的所有礼物ID
            const categoryGiftIds = this.presentList
                .filter(item => item.category && item.category.id === categoryId)
                .map(item => item.id);

            // 统计在心愿单中的数量
            return this.wishList.filter(wishItem =>
                categoryGiftIds.includes(wishItem.idPresent)
            ).length;
        },
        // 获取礼物记录
        getGiftRecordList() {
            this.loadingImgShow = true; // 显示加载图片
            getReceivedList().then(async res => {
                console.log('礼物记录API响应:', res);
                if (res && res.length > 0) {
                    const recordsWithUserInfo = await store.dispatch('userInfo/matchChatListUserInfo', { chatList: res, userIdField: 'idUserFrom', platformUserIdField: 'idUserTo' });
                    console.log('匹配用户信息后的礼物记录:', recordsWithUserInfo);
                    this.giftRecordList = recordsWithUserInfo;
                } else {
                    this.giftRecordList = [];
                }
            }).catch(error => {
                this.giftRecordList = [];
            }).finally(() => {
                this.loadingImgShow = false; // 隐藏加载图片
            });
        },
        // 打开邮件会话
        toChat(item, messageType) {
            console.log('打开邮件会话:', item);
            // 构建用户信息对象，包含必要的字段
            const userInfo = {
                userId: item.idUserFrom, // 发送礼物的用户ID
                platformUserId: item.idUserTo, // 接收礼物的用户ID（当前用户）
                name: item.userDetail?.name || '未知用户',
                avatar_small: item.userDetail?.avatar_small,
                is_online: item.userDetail?.is_online,
                isVip: item.userDetail?.isVip
            };
            // 调用 clickHistory 方法，传递消息类型
            this.$emit('clickHistory', userInfo, messageType);
        },
        onDateRangeChange() {
            console.log('日期范围变化:', this.giftAnalysis.dateRange);
            this.filterGiftData();
        },
        async filterGiftData() {
            this.giftAnalysis.loading = true;
            try {
                // 获取礼物记录数据
                const giftRecords = await getReceivedStatistics({
                    dateFrom: this.formatDateToISO(this.giftAnalysis.dateRange[0]),
                    dateTo: this.formatEndDateToISO(this.giftAnalysis.dateRange[1])
                });

                if (giftRecords && giftRecords.length > 0) {
                    // 匹配用户信息
                    const recordsWithUserInfo = await store.dispatch('userInfo/matchChatListUserInfo', {
                        chatList: giftRecords,
                        userIdField: 'idUserFrom',
                        platformUserIdField: 'idUserTo'
                    });

                    // 根据日期筛选数据
                    let filteredRecords = recordsWithUserInfo;
                    if (this.giftAnalysis.dateRange && this.giftAnalysis.dateRange.length === 2) {
                        const [startDate, endDate] = this.giftAnalysis.dateRange;
                        filteredRecords = recordsWithUserInfo.filter(record => {
                            const recordDate = new Date(record.dateSent);
                            const rangeStartDate = startDate ? new Date(startDate) : null;
                            const rangeEndDate = endDate ? new Date(endDate) : null;

                            if (rangeStartDate && recordDate < rangeStartDate) return false;
                            if (rangeEndDate && recordDate > rangeEndDate) return false;
                            return true;
                        });
                    }

                    // 计算统计数据
                    this.giftAnalysis.totalGifts = filteredRecords.length;
                    this.giftAnalysis.totalCredits = filteredRecords.reduce((sum, record) => sum + (record.gift?.cost || 0), 0);

                    // 统计送礼用户数（去重）
                    const uniqueUsers = new Set(filteredRecords.map(record => record.idUserFrom));
                    this.giftAnalysis.totalUsers = uniqueUsers.size;

                    this.giftAnalysis.filteredData = filteredRecords;
                } else {
                    this.giftAnalysis.totalGifts = 0;
                    this.giftAnalysis.totalCredits = 0;
                    this.giftAnalysis.totalUsers = 0;
                    this.giftAnalysis.filteredData = [];
                }
            } catch (error) {
                console.error('获取礼物统计数据失败:', error);
                this.$message.error('获取礼物统计数据失败！');
                this.giftAnalysis.totalGifts = 0;
                this.giftAnalysis.totalCredits = 0;
                this.giftAnalysis.totalUsers = 0;
                this.giftAnalysis.filteredData = [];
            } finally {
                this.giftAnalysis.loading = false;
            }
        },
        formatGiftTime(timestamp) {
            if (!timestamp) {
                return '';
            }
            // 格式化为 YYYY-MM-DD HH:mm:ss 格式
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        // 将日期转换为ISO格式
        formatDateToISO(dateString) {
            if (!dateString) return null;
            return new Date(dateString).toISOString();
        },
        // 将日期转换为ISO格式（结束日期设置为当天23:59:59）
        formatEndDateToISO(dateString) {
            if (!dateString) return null;
            return new Date(dateString + 'T23:59:59.999Z').toISOString();
        },
        // 初始化礼物数据分析
        initGiftAnalysis() {
            console.log('初始化礼物分析...');
            // 设置默认日期范围（最近30天）
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 30);

            this.giftAnalysis.dateRange = [
                startDate.toISOString().split('T')[0],
                endDate.toISOString().split('T')[0]
            ];

            console.log('设置日期范围:', this.giftAnalysis.dateRange[0], '到', this.giftAnalysis.dateRange[1]);

            // 加载初始数据
            this.filterGiftData();
        },
        // 处理在线筛选开关变化
        handleOnlineFilterChange() {
            // 只有在聊天模式下才重新加载数据
            if (this.bType === 1) {
                this.expandList('reset');
            }
        },

        // 处理搜索
        handleSearch(keyword) {
            this.searchKeyword = keyword
            this.applySearchFilter()
        },

        // 应用搜索过滤
        applySearchFilter() {
            // 搜索条件改变时，关闭所有展开的折叠面板
            this.activeNames = ''

            // 首先过滤掉 isBlocked 为 true 的数据
            let filteredData = this.originalBDataList.filter(user => !user.isBlocked)

            if (!this.searchKeyword || this.searchKeyword.trim() === '') {
                // 如果没有搜索关键词，显示过滤后的数据
                this.bDataList = [...filteredData]
            } else {
                // 根据搜索关键词过滤数据
                const keyword = this.searchKeyword.toLowerCase().trim()
                this.bDataList = filteredData.filter(user => {
                    // 匹配用户ID和姓名
                    const userId = (user.id || user.pdToken || '').toString().toLowerCase()
                    const userName = (user.name || '').toLowerCase()

                    return userId.includes(keyword) || userName.includes(keyword)
                })
            }
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
:deep(.el-collapse-item__content) {
    width: 100%;
}

.liTitle {
    display: flex;
    justify-content: center;
    align-items: center;

    .imgBox {
        position: relative;
        flex-shrink: 0; // 防止图片被压缩

        .isLine {
            position: absolute;
            bottom: 2PX;
            right: 2px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #666666;
        }

    }


    .imgBox {
        position: relative;

        .isLine {
            position: absolute;
            bottom: 2PX;
            right: 2px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #666666;
        }

    }

    .nameBox {
        max-width: 100%;
        min-width: 0; // 允许子元素收缩
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 6px;
    }

    .scBox {
        margin-left: 6px;
        flex-shrink: 0; // 防止图标被压缩
    }
}

.searchBBox {
    width: 100%;

    // display: flex;
    // flex-direction: column;
    // height: 100%;

    .bottomBox {
        position: relative;
        // flex: 1;
        height: 100%;
        // background-color: red;
        overflow-y: scroll;
        overflow-x: hidden;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // align-items: center;
        // width: 100%;

        .tabBox {
            .tabBBox {
                width: 100%;
                height: 40px;
                display: flex;
                align-items: center; // 确保所有子元素垂直居中对齐
                overflow-x: auto;
                overflow-y: hidden;
                background-color: #fff;
                box-shadow: 0 3px 6px 1px #E0E0E0;

                // 自定义滚动条样式
                &::-webkit-scrollbar {
                    height: 4px;
                }

                &::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 2px;
                }

                &::-webkit-scrollbar-thumb {
                    background: rgba(41, 41, 199, 0.3);
                    border-radius: 2px;

                    &:hover {
                        background: rgba(41, 41, 199, 0.5);
                    }
                }

                // Firefox 滚动条样式
                scrollbar-width: thin;
                scrollbar-color: rgba(41, 41, 199, 0.3) transparent;

                .tabBItem {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-width: 80px;
                    padding: 0 16px;
                    height: 100%;
                    flex-shrink: 0;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &:hover {
                        background-color: rgba(41, 41, 199, 0.1);
                    }

                    i {
                        margin-right: 5px;
                    }
                }
            }

            .tabMScroll {
                margin-top: 10px;
                width: 100%;
                height: 40px;
                display: flex;
                overflow-x: auto;
                overflow-y: hidden;

                // 自定义滚动条样式
                &::-webkit-scrollbar {
                    height: 4px;
                }

                &::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 2px;
                }

                &::-webkit-scrollbar-thumb {
                    background: rgba(41, 41, 199, 0.3);
                    border-radius: 2px;

                    &:hover {
                        background: rgba(41, 41, 199, 0.5);
                    }
                }

                // Firefox 滚动条样式
                scrollbar-width: thin;
                scrollbar-color: rgba(41, 41, 199, 0.3) transparent;

                .tabMItem {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 70px;
                    padding: 0 16px;
                    height: 100%;
                    flex-shrink: 0;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &:hover {
                        background-color: rgba(41, 41, 199, 0.1);
                    }

                    .tabContent {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        gap: 4px;

                        .tabIcon {
                            width: 16px;
                            height: 16px;
                            object-fit: contain;
                        }

                        span {
                            font-size: 15px;
                            white-space: nowrap;
                        }
                    }

                    .line {
                        width: 50px;
                        height: 2px;
                        border-radius: 0px 0px 0px 0px;
                        background-color: #2929c7;
                        margin-top: 4px;
                    }

                    .opacityCss {
                        opacity: 0;
                    }
                }

                // 在线筛选开关样式
                .online-filter-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-width: 80px;
                    padding: 0 16px;
                    border-radius: 6px;
                    height: 100%;
                    flex-shrink: 0;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    margin-left: auto; // 将开关推到右侧

                    &:hover {
                        background-color: rgba(41, 41, 199, 0.1);
                    }

                    .online-filter-item {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        white-space: nowrap;
                        height: 100%;

                        :deep(.el-switch__label) {
                            color: #666;
                            font-size: 15px;
                            font-weight: 400;

                            &.is-active {
                                color: #2929c7;
                                font-weight: 500;
                            }
                        }

                        :deep(.el-switch) {
                            .el-switch__core {
                                width: 36px;
                                height: 18px;
                                border-radius: 9px;

                                &:after {
                                    width: 14px;
                                    height: 14px;
                                    border-radius: 50%;
                                }
                            }
                        }
                    }
                }
            }
        }

        .mBox {
            max-height: 400px;
            overflow-y: scroll;
            overflow-x: hidden;
            scrollbar-width: none;
        }

        .userBox {
            margin-bottom: 4px;
            cursor: pointer;
            transition: all 0.3s ease;
            padding: 8px;
            background-color: #F7F9FA;

            &:hover {
                background-color: #e4e7ec;
            }

            &.pinned {
                background-color: #eff6fb;
            }

            .topUserBox {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;

                .pinned_icon {
                    width: 30px;
                    height: 30px;
                    transform: rotate(90deg);
                }

                .leftUser {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex: 1; // 允许左侧区域占据剩余空间
                    min-width: 0; // 允许子元素收缩

                    .imgBox {
                        position: relative;
                        width: 36px;
                        height: 36px;
                        border-radius: 8px;
                        cursor: pointer;

                        .status {
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            width: 10px;
                            height: 10px;
                            border-radius: 50%;
                            background-color: #8F8F8F;
                        }

                        .checkStatus {
                            background-color: #0CD85D;
                        }
                    }

                    .xxBox {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        flex: 1; // 允许内容区域占据剩余空间
                        min-width: 0; // 允许子元素收缩


                        .nameBox {
                            max-width: 100%; // 限制最大宽度为父元素宽度
                            min-width: 0; // 允许子元素收缩
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            margin-left: 6px;
                            font-size: 12px;
                            line-height: 1;

                            &:first-child {
                                font-weight: bold;
                                color: #333333;
                            }

                            &:last-child {
                                font-weight: 400;
                                color: #666666;
                                font-size: 11px;
                            }
                        }
                    }

                }

                .scBox {

                    .scBox {
                        margin-left: 6px;
                        flex-shrink: 0; // 防止图标被压缩
                    }

                    .sccBox {
                        display: flex;
                        flex-shrink: 0; // 防止图标被压缩
                    }

                    .sccBox {
                        display: flex;
                    }

                    .sccBox {
                        display: flex;
                    }
                }
            }

            .bottomUserBox {
                color: #999999;
                line-height: 1;
                margin-top: 10px;

                >span {
                    font-size: 10px;
                }
            }
        }
    }

    :deep(.el-collapse-item__header) {
        background: #F7F9FA !important;
        padding: 10px !important;
        border-bottom: 1px solid #fff;
        transition: all 0.3s ease;

        &:hover {
            background: #e6e9ec !important;
        }
    }

    :deep(.el-collapse-item__wrap) {
        background: #F7F9FA !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}

.active-color {
    color: #2929c7;
}

// 礼物记录样式
.gift-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    .gift-image {
        border: 2px solid #f0f0f0;
        transition: all 0.3s ease;
    }

    .gift-name {
        font-size: 12px;
        color: #666;
        text-align: center;
        max-width: 60px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

// 操作图标样式
.action-icons {
    display: flex;
    gap: 8px;
    margin-left: 10px;

    .action-icon {
        cursor: pointer;
        transition: all 0.3s ease;
        opacity: 0.7;

        &:hover {
            opacity: 1;
            transform: scale(1.1);
        }
    }
}

.loadingImg {
    width: 30px;
    height: 30px;
    margin: 0 auto;
}

// 移出黑名单按钮样式
:deep(.unblock-button) {
    background-color: #fff !important;
    border: 1px solid #2929c7 !important;
    color: #2929c7 !important;
    border-radius: 4px !important;
    padding: 5px 12px !important;
    font-size: 12px !important;
    height: 28px !important;
    line-height: 1 !important;
    transition: all 0.3s ease !important;

    &:hover {
        background-color: #2929c7 !important;
        color: #fff !important;
        border-color: #2929c7 !important;
    }

    &:focus {
        background-color: #2929c7 !important;
        color: #fff !important;
        border-color: #2929c7 !important;
    }
}

// 移出心愿单按钮样式
:deep(.remove-wishlist-button) {
    background-color: #fff !important;
    border: 1px solid #f56c6c !important;
    color: #f56c6c !important;
    border-radius: 4px !important;
    padding: 5px 12px !important;
    font-size: 12px !important;
    height: 28px !important;
    line-height: 1 !important;
    transition: all 0.3s ease !important;

    &:hover {
        background-color: #f56c6c !important;
        color: #fff !important;
        border-color: #f56c6c !important;
    }

    &:focus {
        background-color: #f56c6c !important;
        color: #fff !important;
        border-color: #f56c6c !important;
    }
}

// 加入心愿单按钮样式
:deep(.add-wishlist-button) {
    background-color: #fff !important;
    border: 1px solid #2929c7 !important;
    color: #2929c7 !important;
    border-radius: 4px !important;
    padding: 5px 12px !important;
    font-size: 12px !important;
    height: 28px !important;
    line-height: 1 !important;
    transition: all 0.3s ease !important;

    &:hover {
        background-color: #2929c7 !important;
        color: #fff !important;
        border-color: #2929c7 !important;
    }

    &:focus {
        background-color: #2929c7 !important;
        color: #fff !important;
        border-color: #2929c7 !important;
    }
}

// 礼物分类导航样式 - 固定在顶部
.category-nav-fixed {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #fff;
    padding: 8px;
    margin-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;

    .category-nav-items {
        display: flex;
        overflow-x: auto;
        gap: 12px;
        padding: 4px;

        // 隐藏滚动条但保持功能
        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 2px;

            &:hover {
                background: #a8a8a8;
            }
        }

        .category-nav-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 6px 10px;
            border-radius: 60px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: 2px solid transparent;
            flex-shrink: 0; // 防止项目被压缩
            white-space: nowrap;
            color: #333;
            position: relative; // 为角标定位

            &:hover {
                background-color: #2929c7;
                color: #fff;
            }

            &.active {
                background-color: #f0f0ff;
                border-color: #2929c7;
                font-weight: bold;
                color: #212529;
            }

            .category-nav-icon {
                width: 32px;
                height: 32px;
                border-radius: 4px;
                margin-right: 4px;
                object-fit: cover;
                border-radius: 50%;
            }

            span {
                font-size: 12px;
                white-space: nowrap;
                text-align: center;
            }

            // 心愿单数量角标样式
            .wishlist-badge-count {
                position: absolute;
                top: -3px;
                left: -3px;
                background: #2929c7;
                color: #fff;
                border-radius: 50%;
                min-width: 14px;
                height: 14px;
                font-size: 10px;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 2px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            }
        }
    }
}

// 分类区域样式
.category-section {
    margin-bottom: 20px;

    .category-header {
        background: #f5f7fa;
        padding: 12px 15px;
        margin-bottom: 10px;
        border-left: 4px solid #2929c7;
        scroll-margin-top: 80px; // 滚动定位时的顶部边距，避免被遮挡

        .category-info {
            display: flex;
            align-items: center;
            gap: 10px;

            .category-icon {
                width: 24px;
                height: 24px;
                border-radius: 4px;
                object-fit: cover;
            }

            .category-name {
                font-size: 16px;
                font-weight: 600;
                color: #333;
            }
        }
    }

    .gift-list {
        // 礼物列表使用现有的 userBox 样式

        .wishlist-badge {
            position: absolute;
            top: -5px;
            left: -5px;
            background: #2929c7;
            border-radius: 50%;
            padding: 2px;
        }

        .wishlist-status {
            font-size: 12px;
            color: #2929c7;
            margin-top: 2px;
        }
    }
}

// 礼物数据分析样式
.gift-analysis-container {
    padding: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 15px;

    .filter-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ebebeb;

        .date-filters {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .date-input {
                display: flex;
                flex-direction: column;
                gap: 4px;

                label {
                    font-size: 12px;
                    color: #555;
                    font-weight: 500;
                }

                :deep(.el-date-editor) {
                    width: 100%;

                    .el-input__inner {
                        font-size: 12px;
                        border: 1px solid #dcdfe6;
                        border-radius: 4px;
                        // padding: 0 8px;

                        &:hover {
                            border-color: #c0c4cc;
                        }

                        &:focus {
                            border-color: #409eff;
                        }
                    }

                    .el-input__icon {
                        color: #c0c4cc;
                    }
                }
            }
        }

        .filter-btn {
            background-color: #2929c7;
            color: #fff;
            border: none;
            padding: 8px 12px;
            border-radius: 6px;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s ease;
            width: 100%;
            margin-top: 5px;

            &:hover {
                background-color: #1a1a99;
            }
        }
    }

    .stats-section {
        display: flex;
        flex-direction: row;
        gap: 8px;
        margin-bottom: 15px;
        width: 100%;

        .stat-card {
            text-align: center;
            padding: 8px 12px;
            border-radius: 6px;
            background-color: #f9f9f9;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
            flex: 1;

            &:nth-child(2) {
                flex: 0.8;
            }

            .stat-number {
                font-size: 20px;
                font-weight: bold;
                color: #2929c7;
                margin-bottom: 3px;
            }

            .stat-label {
                font-size: 12px;
                color: #666;
            }
        }
    }

    .table-section {
        width: 100%;
        overflow-x: auto;

        :deep(.el-table) {
            font-size: 12px;
            width: 100%;

            .el-table__header {
                th {
                    padding: 8px 0px;
                    font-size: 12px;
                    white-space: nowrap;

                    .cell {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }

        .gift-name-cell {
            display: flex;
            align-items: center;
            gap: 6px;
            width: 100%;

            .gift-thumbnail {
                width: 20px;
                height: 20px;
                border-radius: 3px;
                object-fit: cover;
                flex-shrink: 0;
            }

            span {
                font-size: 12px;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                flex: 1;
                min-width: 0;
            }
        }

        .sender-cell {
            display: flex;
            align-items: center;
            gap: 6px;
            width: 100%;

            .sender-avatar {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                object-fit: cover;
                flex-shrink: 0;
            }

            span {
                font-size: 12px;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                flex: 1;
                min-width: 0;
            }
        }

        .credits-amount {
            font-size: 12px;
            font-weight: bold;
            color: #2929c7;
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .gift-analysis-container {
        padding: 8px;

        .filter-section {
            .date-filters {
                .date-input {
                    :deep(.el-date-editor) {
                        .el-input__inner {
                            font-size: 11px;
                        }
                    }
                }
            }

            .filter-btn {
                padding: 6px 10px;
                font-size: 11px;
            }
        }

        .stats-section {
            .stat-card {
                padding: 6px 10px;

                .stat-number {
                    font-size: 18px;
                }

                .stat-label {
                    font-size: 11px;
                }
            }
        }

        .table-section {

            :deep(.el-table) {
                font-size: 11px;

                .el-table__header th {
                    padding: 6px 0px;
                    font-size: 11px;

                    .cell {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            .gift-name-cell {
                gap: 4px;

                .gift-thumbnail {
                    width: 18px;
                    height: 18px;
                }

                span {
                    font-size: 11px;
                    flex: 1;
                    min-width: 0;
                }
            }

            .sender-cell {
                gap: 4px;

                .sender-avatar {
                    width: 16px;
                    height: 16px;
                }

                span {
                    font-size: 11px;
                    flex: 1;
                    min-width: 0;
                }
            }

            .credits-amount {
                font-size: 11px;
            }
        }
    }
}
</style>